import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "h-80vh" }
const _hoisted_2 = { class: "d-table" }
const _hoisted_3 = { class: "d-table-cell" }
const _hoisted_4 = {
  class: "card border-0 box-shadow border-radius-10 mb-4 w-100",
  style: {"max-width":"500px","margin":"auto"}
}
const _hoisted_5 = { class: "card-body p-30" }
const _hoisted_6 = { class: "text-center mb-4" }
const _hoisted_7 = {
  key: 0,
  class: "fs-18 fw-semibold mb-2 text-danger"
}
const _hoisted_8 = { class: "form-group mb-4" }
const _hoisted_9 = { class: "form-group mb-4" }
const _hoisted_10 = { class: "password-wrapper position-relative" }
const _hoisted_11 = ["type"]
const _hoisted_12 = { class: "form-group mb-4 d-flex justify-content-between" }
const _hoisted_13 = { class: "form-group mb-4" }
const _hoisted_14 = ["disabled"]

import { ref, computed } from 'vue'
import type { UserCredentials } from "@/types/auth"
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { storeToRefs } from "pinia"
import useAuth from "@/use/useAuth"


const __default__ = {}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'SignIn',
  setup(__props) {

const { login } = useAuth()
const { error } = storeToRefs(useAuthStore())
const router = useRouter()

const state = ref<UserCredentials>({
  email: "",
  password: ""
})
const showPassword = ref(false)
const togglePasswordVisibility = () => {
  showPassword.value = !showPassword.value;
}

const buttonDisabled = computed(() => { 
  return !state.value.email  || !state.value.password 
}) 
const signIn = async () => {
  const response: boolean = await login(state.value)  

  if (response)
    router.push("/")
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "fs-24 fw-semibold mb-2" }, "E-GCR Portal", -1)),
              (!!_unref(error))
                ? (_openBlock(), _createElementBlock("h5", _hoisted_7, _toDisplayString(_unref(error)), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("form", {
              onSubmit: _withModifiers(signIn, ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_8, [
                _cache[3] || (_cache[3] = _createElementVNode("label", { class: "label" }, "Email Address", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: "",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.value.email) = $event))
                }, null, 512), [
                  [_vModelText, state.value.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[4] || (_cache[4] = _createElementVNode("label", { class: "label" }, "Password", -1)),
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    type: showPassword.value ? 'text' : 'password',
                    id: "password",
                    class: "form-control",
                    placeholder: "",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.value.password) = $event))
                  }, null, 8, _hoisted_11), [
                    [_vModelDynamic, state.value.password]
                  ]),
                  _createElementVNode("i", {
                    style: {"color":"#919aa3","font-size":"16px","right":"15px !important","cursor":"pointer"},
                    class: _normalizeClass([showPassword.value ? 'ri-eye-line' : 'ri-eye-off-line', "password-toggle-icon translate-middle-y top-50 end-0 position-absolute"]),
                    "aria-hidden": "true",
                    onClick: togglePasswordVisibility
                  }, null, 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "c-form-check form-check" }, null, -1)),
                _createVNode(_component_router_link, {
                  to: "/forget-password",
                  class: "text-primary fs-14 text-decoration-none"
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode(" Forget you password? ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "default-btn w-100 d-block",
                  disabled: buttonDisabled.value
                }, " Sign In ", 8, _hoisted_14)
              ])
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}
}

})